import { useMemo } from 'react';

import { defaultOtherFilters } from '~/components/Filters/OtherFilters/OtherFilters';
import { usePublicDefaultFastFilterBarOptions } from '~/components/Filters/v2/hooks/usePublicDefaultFastFilterBarOptions';
import { useFiltersContext } from '~/providers/FiltersProvider';
import { getExcludedFiltersFromImmutableFilters } from '~/utils/filters/fastFiltersUtils';

export const usePublicFastFilterOptions = () => {
  const { filters, moreFilters, moreCustomFields, disabledFilters } = usePublicDefaultFastFilterBarOptions();
  const { immutableFilters = {} } = useFiltersContext();

  return useMemo(() => {
    const { excludedFilterTypes, excludedOtherFilters, excludedCustomFields } =
      getExcludedFiltersFromImmutableFilters(immutableFilters);

    const filtersInBar = filters.filter((filter) => {
      if (filter.type === 'customField') {
        return !excludedCustomFields.has(filter.customField!.id);
      }
      return !excludedFilterTypes.has(filter.type);
    });

    const filtersInDropdown = moreFilters.filter((filter) => !excludedFilterTypes.has(filter));

    const customFieldsInDropdown = moreCustomFields.filter((cf) => !excludedCustomFields.has(cf.id));

    const otherFilters = defaultOtherFilters.filter((filter) => !excludedOtherFilters.has(filter));

    return {
      filtersInBar,
      filtersInDropdown,
      customFieldsInDropdown,
      otherFilters,
      disabledFilters,
    };
  }, [immutableFilters, filters, moreFilters, moreCustomFields, disabledFilters]);
};
